import { Box, Button, Checkbox, TableCell, TableRow, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router';

export function ProductManagerTableRow({ 
  row,
  open,
  toggleRowOpen,
  saveSpoPrice,
  stateFields,
  stateSetters,
  handleChange,
  inputRefs,
  refetch,
  filters, setFilters,
  isAnyPlaces,
  removeArrayElement,
  itemsProcessing }) {
  const navigate = useNavigate();
  const { is, count, } = isAnyPlaces(row.place, row.stand, row.shelf)
  
  const [pendingSave, setPendingSave] = useState(false);
  const [currentField, setCurrentField] = useState(null);

  useEffect(() => {
    if (pendingSave && currentField) {
      const timeoutId = setTimeout(() => {
        saveSpoPrice(row);
        refetch();
        setFilters({...filters, refetch: !filters.refetch});
        setPendingSave(false);
        setCurrentField(null);
        toggleRowOpen(row.sku);
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [pendingSave, stateSetters[currentField]]);

  const updateArrayValue = (currentString, index, newValue) => {
    if (typeof currentString !== 'string' || index < 0) return currentString;
    // Разделяем строку на массив
    const parts = currentString.split('/');
    // Убеждаемся, что индекс не выходит за пределы массива
    if (index >= parts.length) {
      // Расширяем массив пустыми строками при необходимости
      parts.push(...Array(index - parts.length + 1).fill(''));
    }
    // Обновляем значение по индексу
    parts[index] = newValue;
    // Соединяем обратно в строку
    console.log(parts);
    return parts.join('/');
  };
  const [openOrders, setOpenOrders] = useState(false);
  const ordersAraay = itemsProcessing.find((elem) => elem.sku == row.sku)?.orders;
  // console.log(ordersAraay);

  return (
      <React.Fragment>
        {is ? 
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell sx={{
            width: '24px',
            padding: '16px'
          }}>
            <Checkbox color={"success"}/>
          </TableCell>
          <TableCell component='th' scope='row' sx={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
            <img src={row.img} style={{ width: '50px', height: '50px' }} alt='preview' />
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%'}} title={row.name}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                {row.name}
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', color: 'gray', width: '100%', gap: '5px'}}>
                <span>{row.sku}</span> {row.nameProveedor && <div> | </div>} {row.nameProveedor}
              </Box>
            </Box>
          </TableCell>
          {stateFields.map((field, i) => (
            <TableCell key={field}>
              {
              Array.from(Array(count).keys()).map((elem, index) => 
              open ? (
              <>
                <TextField
                  key={index}
                  size='small'
                  value={stateSetters[field][0][row.sku] !== undefined ? stateSetters[field][0][row.sku]?.toString()?.split('/')[index] : '' || row[field]?.toString()?.split('/')[index]}
                  onChange={(event) => {
                    if (field == 'shelf') {
                      handleChange(field, (updateArrayValue(stateSetters[field][0][row.sku]||row[field]?.toString(),index,event.target.value)).replace(' ', ' ').replace(/[0-9]/, ''), event, row.sku)
                    } else {
                      handleChange(field, (updateArrayValue(stateSetters[field][0][row.sku]||row[field]?.toString(),index,event.target.value)).replace(' ', ''), event, row.sku)
                    }
                    }}
                  sx={{ width: '100px' }}
                  inputRef={(el) => (inputRefs.current[row.sku] = el)}
                  disabled={field === 'ourPrice' || field === 'marketPriceCP'}
                />
                <Button
                  onClick={() => {
                    handleChange(
                      field,
                      removeArrayElement(stateSetters[field][0][row.sku]||row[field]?.toString(), index),
                      event,
                      row.sku
                    )
                    setCurrentField(field);
                    setPendingSave(true);
                  }}
                >х
                </Button>
              </>
              ) : (
                <Box key={index}>
                  {stateSetters[field][0][row.sku]?.toString()?.split('/')[index] || row[field]?.toString()?.split('/')[index]}
                </Box>
              )
            )}
            {field !== 'ourPrice' && field !== 'marketPriceCP' && field !== 'stock' && open && (
              <Button
                onClick={() => {
                  handleChange(
                    field,
                    (stateSetters[field][0][row.sku] || row[field]?.toString()) + '/New',
                    event,
                    row.sku
                  );
                  setCurrentField(field);
                  setPendingSave(true);
                }}
              >+
              </Button>
            )}
          </TableCell>
          ))}            
          <TableCell>
            {row.updatedAt ? (row.updatedAt !== 'Unknown' ? row.updatedAt.split('/').join('.') + ' ' : null) : null}
            {row.updatedBy ? (row.updatedBy !== 'Unknown' ? row.updatedBy : null) : null}
          </TableCell>
          <TableCell>
            {open ?
              <Button variant='contained' color='primary' size='small' onClick={() => {
                toggleRowOpen(row.sku);
                saveSpoPrice(row);
                refetch()
                setFilters({...filters, refetch: !filters.refetch})
              }}> {/*saveSpoPrice(row)*/}
                Save
              </Button>
              :
              <Button variant='contained' color='primary' size='small' onClick={() => toggleRowOpen(row.sku)}> {/*saveSpoPrice(row)*/}
                Edit
              </Button>
            }
          </TableCell>
        </TableRow> : 
        <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <TableCell sx={{
            width: '24px',
            padding: '16px'
          }}>
            <Checkbox color={"success"}/>
          </TableCell>
          <TableCell component='th' scope='row' sx={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
            <img src={row.img} style={{ width: '50px', height: '50px' }} alt='preview' />
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%'}} title={row.name}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                {row.name}
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', color: 'gray', width: '100%', gap: '5px'}}>
                <span>{row.sku}</span> {row.nameProveedor && <div> | </div>} {row.nameProveedor}
              </Box>
            </Box>
          </TableCell>
          {stateFields.map((field) => (
              <TableCell 
                key={field}
                sx={{ fontWeight: field == 'totalQuantity' ? 'bold' : 'regular', position: 'relative' }}
                onMouseEnter={() => {
                  if (field !== 'ourPrice') {
                    setOpenOrders(true);
                  }
                }}  
                onMouseLeave={() => {
                  if (field !== 'ourPrice') {
                    setOpenOrders(false);
                  }
                }}
              >
                {open ? (
                  <TextField
                    size='small'
                    value={stateSetters[field][0][row.sku] !== undefined ? stateSetters[field][0][row.sku] : '' || row[field]}
                    onChange={(event) => {
                      if (field == 'shelf') {
                        handleChange(field, (event.target.value).replace(' ', '').replace(/[0-9]/, ''), event, row.sku)
                      } else {
                        handleChange(field, (event.target.value).replace(' ', ''), event, row.sku)
                      }
                      }}
                    sx={{ width: '100px' }}
                    inputRef={(el) => (inputRefs.current[row.sku] = el)}
                    disabled={field === 'ourPrice' || field === 'marketPriceCP'}
                  />
                ) : (field == 'stock' ? parseFloat(stateSetters[field][0][row.sku] || row[field])?.toFixed(2) : 
                  stateSetters[field][0][row.sku] || row[field]
                )}
                {field == 'totalQuantity' && openOrders && ordersAraay?.length > 0 && 
                <Box 
                  onMouseEnter={() => {
                    if (field !== 'ourPrice') {
                      setOpenOrders(true);
                    }
                  }}  
                  onMouseLeave={() => {
                    if (field !== 'ourPrice') {
                      setOpenOrders(false);
                    }
                  }}
                  sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'absolute',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    color: 'gray',
                    width: '100px',
                    height: 'fit-content',
                    padding: '5px',
                    gap: '5px',
                    background: 'white',
                    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
                    borderRadius: '5px',
                    zIndex: '100',
                    }}>
                  {ordersAraay?.map((el) => (
                    <Button  key={el}
                      onClick={() => {
                        navigate('/admin/orders/'+el)
                      }}
                    >{el?.slice(-6)}</Button>
                  ))}
                </Box>}
              </TableCell>
          ))}            
          <TableCell>
            {row.updatedAt ? (row.updatedAt !== 'Unknown' ? row.updatedAt.split('/').join('.') + ' ' : null) : null}
            {row.updatedBy ? (row.updatedBy !== 'Unknown' ? row.updatedBy : null) : null}
          </TableCell>
          <TableCell>
            {open ?
              <Button variant='contained' color='primary' size='small' onClick={() => {
                toggleRowOpen(row.sku);
                saveSpoPrice(row);
                refetch()
                setFilters({...filters, refetch: !filters.refetch})
              }}> {/*saveSpoPrice(row)*/}
                Save
              </Button>
              :
              <Button variant='contained' color='primary' size='small' onClick={() => toggleRowOpen(row.sku)}> {/*saveSpoPrice(row)*/}
                Edit
              </Button>
            }
          </TableCell>
        </TableRow>
        }
      </React.Fragment>
  )
}